








































































import TreeContainer from '@/components/tree/tree.vue'; // 导入树状图组件
import { Component, Vue, Prop } from 'vue-property-decorator';
import { TableStripe } from '@/mixins/tableStripe';
import logger from 'vuex/types/logger';
import { roleServe, userServe } from '@/api/installServer';

@Component({
  components: { TreeContainer },
  mixins: [TableStripe],
})
export default class SetRole extends Vue {
  @Prop(Object) roleData!: any; // 接受到的用户信息
  @Prop(Boolean) contentFlag!: boolean; // 接受到判断显示权限或角色
  roleIdList: any = []; // 角色id列表
  scrollbar = true;
  // 表单数据
  formDate: any = {
    id: '',
    name: '', // 登录账号
  };
  postIdList: any = []; // 岗位id列表
  // 表单验证规则
  formRules: object = {
    name: [{ required: true, trigger: 'focus' }],
    nickName: [{ required: true, trigger: 'focus' }],
  };
  // 分配角色表格数据
  roleTableDate: any[] = [
    { roleName: '临时工', roleCode: 'deepThroat', id: 1 },
    { roleName: '又来背锅了', roleCode: 'deepThroat', id: 2 },
    { roleName: '我都信了', roleCode: 'deepThroat', id: 3 },
  ];
  selectRole: any[] = []; // 分配角色表格中被选中的数组
  // 树状图的数据
  treeData: Array<any> = [
    {
      id: 1,
      label: '一级 1',
      children: [
        {
          id: 4,
          label: '二级 1-1',
          children: [
            {
              id: 9,
              label: '三级 1-1-1',
            },
            {
              id: 10,
              label: '三级 1-1-2',
              children: [
                {
                  id: 11,
                  label: '四级 1-1-2-1',
                },
                {
                  id: 12,
                  label: '四级 1-1-2-2',
                },
              ],
            },
          ],
        },
      ],
    },
    {
      id: 2,
      label: '一级 2',
      children: [
        {
          id: 5,
          label: '二级 2-1',
        },
        {
          id: 6,
          label: '二级 2-2',
        },
      ],
    },
    {
      id: 3,
      label: '一级 3',
      children: [
        {
          id: 7,
          label: '二级 3-1',
        },
        {
          id: 8,
          label: '二级 3-2',
        },
      ],
    },
  ];

  // Vue 创建数据生命周期
  created() {
    console.log(this.roleData);
    this.roleData.postList.map((res: any) => {
      console.log(res, 425);
      this.postIdList.push(res.postId);
    });
    console.log(this.postIdList, 176);
    this.getTableData();
  }

  mounted() {
    this.hasScrollbar();
  }

  hasScrollbar() {
    const dom: any = document.querySelector('.main');
    this.scrollbar = dom.scrollHeight > dom.clientHeight || dom.offsetHeight > dom.clientHeight;
    if (dom.scrollHeight > dom.clientHeight || dom.offsetHeight > dom.clientHeight) {
      console.log('true456');
    } else {
      console.log('false456');
    }
  }

  getTableData() {
    // 发起接口请求，获取角色数据
    roleServe
      .getRoleDataListAll({ spaceId: this.roleData.spaceId })
      .then((res: any) => {
        console.log(res, 193);
        this.roleTableDate = res.data;

        if (this.contentFlag) {
          this.formDate = this.roleData;
          this.$nextTick(() => {
            this.formDate.roleList.map((res: any) => {
              this.roleTableDate.map((re: any) => {
                if (res.roleId === re.id) {
                  (this.$refs.roleTableRef as any).toggleRowSelection(re, true);
                }
              });
            });
          });
        }
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  /**
   * @todo 后期需要优化的部分
   * @desc  每当表格单行选中状态发生变化时触发，将被选中的数组赋值。
   * @param1 表格上被选中的数组
   * @returns 暂无
   */
  handleSelectionChange(val: any) {
    this.roleIdList = [];
    if (val) {
      val.map((re: any) => {
        this.roleIdList.push(re.id);
      });
    } else {
      this.roleIdList = [];
    }
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 处理分配角色 table 点击事件
   * @param1 row：点击的这一行数据
   * @returns 暂无
   */
  handleRowClick(row: any): void {
    (this.$refs.roleTableRef as any).toggleRowSelection(row);
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击机构权限树状图会触发，得到被选中的数据对象。
   * @param1 data: 得到的数据对象。
   * @returns 暂无
   */
  getOrganChecked(data: any) {
    console.log(data);
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击公司权限树状图会触发，得到被选中的数据对象
   * @param1 data: 得到的数据对象。=
   * @returns 暂无
   */
  getCompanyChecked(data: any) {
    console.log(data);
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击保存按钮保存内容。
   * @param1 暂无
   * @returns 暂无
   */
  save(): void {
    const fromStr: any = 'formData';
    const formComponent: any = this.$refs[fromStr];
    formComponent.validate((valid: any) => {
      if (!valid) {
        return;
      }
      this.editFunctionData();
    });
  }

  /**
   * 【接口】编辑功能
   */
  private async editFunctionData() {
    userServe
      .editUserData({ ...this.formDate, roleIdList: this.roleIdList, postIdList: this.postIdList })
      .then((res: any) => {
        if (res.code === '200') {
          this.$message.success('保存成功');
          this.close(); // 返回到父级页面
        }
      })
      .catch(() => {
        this.$message.error('保存失败,请稍后重试!');
      });
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 关闭当前页面，返回上一级。
   * @param1 暂无
   * @returns 暂无
   */
  close(): void {
    this.$emit('update:flag', 1);
  }
}
